import { Model, modelRegistry } from './Model';
import { WarehouseTransferItem } from './WarehouseTransferItem';
import { Warehouse } from './Warehouse';
import Printable from '../print/Printable';
import { documentHeader, documentLines, documentSignatures, documentTable, factLine } from '../print/DocumentLayout';
import { I18n } from '../wrappers/I18n';
import Store from '../wrappers/Store';
import moment from 'moment-timezone';
export class WarehouseTransfer extends Model {
    static entity = 'warehouse_transfers';
    id = null;
    number = null;
    date = null;
    from_warehouse_id = null;
    to_warehouse_id = null;
    user_id = null;
    comment = null;
    created_at = null;
    updated_at = null;
    items = [];
    from_warehouse = null;
    to_warehouse = null;
    user = null;
    static fields() {
        return {
            id: this.attr(null),
            number: this.attr(null),
            date: this.attr(null),
            from_warehouse_id: this.attr(null),
            to_warehouse_id: this.attr(null),
            user_id: this.attr(null),
            comment: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            items: this.attr([], (value) => (value || []).map(item => new WarehouseTransferItem(item))),
            from_warehouse: this.attr(null, (value) => value ? new Warehouse(value) : null),
            to_warehouse: this.attr(null, (value) => value ? new Warehouse(value) : null),
            user: this.attr(null, (value) => value ? { id: Number(value.id), name: String(value.name) } : null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getTotalCount() {
        return this.items.reduce((acc, cur) => acc + cur.getCount(), 0);
    }
    getPrintable() {
        const pr = new Printable();
        const venue = Store.get('tenant')?.venue;
        if (!venue)
            return pr;
        documentHeader(pr, {
            title: I18n.t('warehouse_transfers.heading'),
            facts: factLine([I18n.t('warehouse_transfers.number'), this.number], [I18n.t('general.date'), moment(this.date).format('DD.MM.YYYY.')]),
            venueName: venue.name,
            venueLine: `${I18n.t('general.tax_id_number')}: ${venue.tax_id_number}`,
        });
        documentLines(pr, [
            factLine([I18n.t('warehouse_transfers.from_warehouse'), this.from_warehouse?.name], [I18n.t('warehouse_transfers.to_warehouse'), this.to_warehouse?.name]),
            factLine([I18n.t('general.comment'), this.comment]),
        ]);
        const columns = [
            { label: I18n.t('general.number'), kind: 'index' },
            { label: I18n.t('general.code'), kind: 'code' },
            { label: I18n.t('general.inventory_item'), kind: 'name' },
            { label: I18n.t('warehouse_transfers.count'), kind: 'figure' },
        ];
        const rows = this.items.map((item, index) => [
            String(index + 1),
            item.getProductCode(),
            item.getProductName(),
            `${item.getCount()} ${item.getUnitOfMeasure()}`,
        ]);
        documentTable(pr, columns, rows, { density: 'regular' });
        documentSignatures(pr, [I18n.t('warehouse_transfers.handed_over_by'), I18n.t('warehouse_transfers.received_by')]);
        return pr;
    }
}
export default WarehouseTransfer;
modelRegistry.register('WarehouseTransfer', WarehouseTransfer);
//# sourceMappingURL=WarehouseTransfer.js.map